<template>
  <div class="container container-bg">
    <app-intro></app-intro>
    <app-calendar></app-calendar>
    <app-location></app-location>
  </div>
</template>

<script>
import Intro from '../components/Intro.vue';
import Calendar from '../components/Calendar.vue';
import Location from '../components/Location.vue';

export default {
  name: 'Home',
  metaInfo: {
    title: 'Hu-Nora Family Cabin',
    titleTemplate: '%s',
    meta: [{ name: ' og:title', content: 'Hu-Nora Capron Family Cabin' }]
  },
  components: {
    appIntro: Intro,
    appCalendar: Calendar,
    appLocation: Location
  }
};
</script>
